export const onFieldValidated = (e, f) => {
  // @params e = field errors, f = schema field object
  f.customOptions.isValid = (e.length === 0);
};
